import { useState } from 'react';
import { Button, Typography, useTheme } from '@material-ui/core';
import { useApi } from '@backstage/core-plugin-api';
import { identityApiRef } from '@backstage/core-plugin-api';

export const BackstageTokenGenerator = () => {
  const identityApi = useApi(identityApiRef);

  // use principal theme
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [generatedToken, setGeneratedToken] = useState<string | null>(null);

  const handleGenerateToken = async () => {
    const { token } = await identityApi.getCredentials();
    setGeneratedToken(token ?? null);
  };

  return (
    <div>
      <Button
        variant="contained"
        style={{
          backgroundColor: isDark
            ? theme.palette.primary.dark
            : theme.palette.primary.main,
          color: theme.palette.banner.text,
        }}
        onClick={handleGenerateToken}
      >
        Generate Backstage Token
      </Button>
      {generatedToken && (
        <>
          <Typography variant="body1" style={{ marginTop: '16px' }}>
            Generated Token:
          </Typography>

          <Typography
            variant="body2"
            style={{
              marginTop: '8px',
              backgroundColor: theme.palette.pinSidebarButton.background,
              color: theme.palette.common.black,
              padding: '8px',
              borderRadius: '4px',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
            }}
          >
            Bearer {generatedToken}
          </Typography>
        </>
      )}
      {generatedToken && (
        <Button
          variant="outlined"
          style={{ color: theme.palette.secondary.main, marginTop: '16px' }}
          onClick={() => navigator.clipboard.writeText(`${generatedToken}`)}
        >
          Copy Token
        </Button>
      )}
    </div>
  );
};

export default BackstageTokenGenerator;
